import { Box, Stack, Typography } from '@mui/material';
import { ReactComponent as EyeIcon } from 'assets/icons/EyeGray.svg';
import { ReactComponent as HandIcon } from 'assets/icons/Hand.svg';
import { ReactComponent as LockedComputerIcon } from 'assets/icons/LockedComputer.svg';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { styles } from './DataProtectionGuarantees.styles';

export const DataProtectionGuarantees: FC = () => {
  const { t } = useTranslation();

  const content = [
    {
      Icon: EyeIcon,
      text: t('products:uploadDocument.dataProtectionGuarantees.content1.text'),
      title: t('products:uploadDocument.dataProtectionGuarantees.content1.title'),
    },
    {
      Icon: LockedComputerIcon,
      text: t('products:uploadDocument.dataProtectionGuarantees.content2.text'),
      title: t('products:uploadDocument.dataProtectionGuarantees.content2.title'),
    },
    {
      Icon: HandIcon,
      text: t('products:uploadDocument.dataProtectionGuarantees.content3.text'),
      title: t('products:uploadDocument.dataProtectionGuarantees.content3.title'),
    },
  ];

  return (
    <Stack spacing={3} sx={styles.textBox}>
      {content.map((item) => (
        <Stack key={item.title} direction="row" spacing={3}>
          <Box sx={styles.icon}>
            <item.Icon />
          </Box>
          <Stack>
            <Typography variant="bodyStrongM">{item.title}</Typography>
            <Typography color="textSecondary" variant="bodyM">
              {item.text}
            </Typography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
